module.exports = __webpack_public_path__ + "static/media/shutterstock_1712779543-reduced-60.190b374f.jpg";